import React from 'react';
import { Alert } from '@mantine/core';
import { useQuery } from '@apollo/client';
import { IconAlertTriangle } from '@tabler/icons-react';

import { GET_APP_CONFIG } from '../../apollo/queries/appConfig';
import { useUser } from '../../hooks/useUser';

const DEFAULT_MESSAGE =
    'A price change freeze is active. Requests will be escalated to Operations Executive for approval before procurement can proceed.';

type Props = {
    divisionalManagerOnly?: boolean;
};

export function PriceChangeFreezeBanner({
    divisionalManagerOnly = false,
}: Props) {
    const { data } = useQuery(GET_APP_CONFIG);
    const { isDivisionManager, isStoreManager } = useUser();

    if (divisionalManagerOnly && !isDivisionManager && !isStoreManager) {
        return null;
    }

    if (!data?.appConfig?.priceChangeFreezeIsActive) {
        return null;
    }

    const custom = data.appConfig.priceChangeFreezeBannerMessage?.trim();

    return (
        <Alert
            icon={<IconAlertTriangle />}
            color="orange"
            title="Price change freeze"
        >
            {custom || DEFAULT_MESSAGE}
        </Alert>
    );
}
